import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import { Label, PieChart, Pie, Sector, Cell, Tooltip } from 'recharts';
import { Spinner } from 'components';
import * as styles from './AdsPlanLeftCol.scss';

var AdsPlanLeftCol = /*#__PURE__*/function (_Component) {
  _inherits(AdsPlanLeftCol, _Component);

  var _super = _createSuper(AdsPlanLeftCol);

  function AdsPlanLeftCol(props) {
    var _this;

    _classCallCheck(this, AdsPlanLeftCol);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "calculatePlannedAdsTotal", function (adsPlan) {
      if (adsPlan && adsPlan.AdsPlannerCategories) {
        return adsPlan.AdsPlannerCategories.reduce(function (accumulator, cat) {
          return accumulator + parseInt(cat.budget);
        }, 0);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "calculateCreatedAdsTotal", function (adsPlan) {
      if (adsPlan && adsPlan.AdsPlannerCategories) {
        var builtAdsTotal = adsPlan.AdsPlannerCategories.reduce(function (total, cat) {
          // skip post types, we handle below
          if (cat.type === 'SUBSCRIBED_POSTS' || cat.type === 'CUSTOM_POSTS') {
            return total;
          }

          var adsCatTotal = 0;

          if (cat.AdsPlannerAds.length) {
            adsCatTotal = cat.AdsPlannerAds.reduce(function (accumulator, ad) {
              if (ad.createdFacebookAdId || ad.createdInternalAdId) {
                return accumulator + parseInt(ad.budget);
              }

              return accumulator;
            }, 0);
          }

          return total + adsCatTotal;
        }, 0);
        var promotedPostsTotal = adsPlan.AdsPlannerCategories.reduce(function (total, cat) {
          if (cat.type === 'WEBSITE_TRAFFIC' || cat.type === 'LEADS' || cat.type === 'PAGE_LIKES') {
            return total;
          }

          var postsCatTotal = 0;

          if (cat.type === 'CUSTOM_POSTS' && cat.AdsPlannerAds.length) {
            postsCatTotal = cat.AdsPlannerAds.reduce(function (accumulator, ad) {
              if (ad.PostAdvertisement && ad.PostAdvertisement.id) {
                return accumulator + parseInt(ad.budget);
              }

              return accumulator;
            }, 0);
          }

          if (cat.type === 'SUBSCRIBED_POSTS' && cat.SubscribedPostBoost.countOfPosts) {
            postsCatTotal += parseInt(cat.budget);
          }

          return total + postsCatTotal;
        }, 0);
        return builtAdsTotal + promotedPostsTotal;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderChartTooltip", function (data) {
      var label = '';
      var value = 0;

      if (data.payload && data.payload[0] && data.payload[0].payload) {
        label = data.payload[0].payload.prettyName;
        value = _this.props.formatCurrency(data.payload[0].payload.value, false);
      }

      return /*#__PURE__*/React.createElement("div", {
        className: styles.tooltipWrap
      }, /*#__PURE__*/React.createElement("span", null, "".concat(label, " - ").concat(value)));
    });

    _defineProperty(_assertThisInitialized(_this), "formatCatData", function (adsPlan) {
      var colors = {
        APP_INSTALLS: 'salmon',
        BRAND_AWARENESS: 'coral',
        CONVERSIONS: 'khaki',
        EVENT_RESPONSES: 'royalblue',
        LOCAL_AWARENESS: 'mistyrose',
        OFFER_CLAIMS: 'forestgreen',
        PRODUCT_CATALOG_SALES: 'olive',
        VIDEO_VIEWS: 'cyan',
        CUSTOM_POSTS: '#b8d1eb',
        LEADS: '#a5bc8d',
        PAGE_LIKES: '#bd99db',
        SUBSCRIBED_POSTS: '#ba9f86',
        WEBSITE_TRAFFIC: '#fae73e'
      };
      var prettyNames = {
        APP_INSTALLS: 'App Install Ads',
        BRAND_AWARENESS: 'Brand Awareness Ads',
        CONVERSIONS: 'Conversion Ads',
        EVENT_RESPONSES: 'Event Response Ads',
        LOCAL_AWARENESS: 'Local Awareness Ads',
        OFFER_CLAIMS: 'Offer Claim Ads',
        PRODUCT_CATALOG_SALES: 'Product Ads',
        VIDEO_VIEWS: 'Video Ads',
        CUSTOM_POSTS: 'Custom Post Boosts',
        LEADS: 'Lead Ads',
        PAGE_LIKES: 'Page Like Ads',
        SUBSCRIBED_POSTS: 'Subscribed Post Boosts',
        WEBSITE_TRAFFIC: 'Website Traffic Ads'
      };
      var cats = adsPlan.AdsPlannerCategories ? adsPlan.AdsPlannerCategories.sort(function (a, b) {
        if (a.type < b.type) return -1;
        if (a.type > b.type) return 1;
        return 0;
      }) : [];
      return cats.map(function (cat) {
        return {
          name: cat.type,
          value: parseInt(cat.budget) / 100,
          color: colors[cat.type],
          prettyName: prettyNames[cat.type]
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderLegend", function (catData) {
      var thing = null;

      if (catData && catData.length) {
        thing = catData.map(function (cd, index) {
          if (cd.value) {
            return /*#__PURE__*/React.createElement("div", {
              key: "legend_".concat(index),
              className: styles.legendText
            }, /*#__PURE__*/React.createElement("span", {
              className: styles.legendColorCircle,
              style: {
                backgroundColor: cd.color
              }
            }), " ", cd.prettyName, ":", ' ', _this.props.formatCurrency(cd.value, false));
          }
        });
      }

      return thing;
    });

    _defineProperty(_assertThisInitialized(_this), "renderPieChart", function (adsPlan) {
      var data = _this.formatCatData(adsPlan);

      var remainingBudget = parseInt(adsPlan.budget) - _this.calculatePlannedAdsTotal(adsPlan);

      if (remainingBudget > 0) {
        data.push({
          name: 'Uncategorized',
          value: remainingBudget / 100,
          color: '#f1f1f1',
          prettyName: 'Unplanned Ads'
        });
      }

      return /*#__PURE__*/React.createElement(PieChart, {
        width: 290,
        height: 290
      }, /*#__PURE__*/React.createElement(Pie, {
        data: data,
        dataKey: "value",
        labelLine: false,
        label: function label(data) {
          var value = data.payload.value;

          if (value) {
            return /*#__PURE__*/React.createElement("text", {
              x: data.x,
              y: data.y,
              fill: "black",
              fontSize: "15px",
              fontFamily: "'Open Sans', sans-serif",
              textAnchor: "middle"
            }, _this.props.formatCurrency(value, false));
          }

          return null;
        }
      }, data.map(function (d, index) {
        return /*#__PURE__*/React.createElement(Cell, {
          key: index,
          fill: d.color
        });
      })), /*#__PURE__*/React.createElement(Tooltip, {
        content: _this.renderChartTooltip
      }));
    });

    _this.state = {
      openAdsFocusDropdown: false
    };
    return _this;
  }
  /** *********************************************************
   CUSTOM METHODS
   ***********************************************************/


  _createClass(AdsPlanLeftCol, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          adsPlan = _this$props.adsPlan,
          stepIndex = _this$props.stepIndex;
      var plannedAdsTotal = adsPlan ? this.calculatePlannedAdsTotal(adsPlan) : 0;
      var createdAdsTotal = adsPlan ? this.calculateCreatedAdsTotal(adsPlan) : 0;
      var step1ColorClass = parseInt(adsPlan.budget) === plannedAdsTotal ? 'green' : 'red';
      var step2ColorClass = plannedAdsTotal === createdAdsTotal ? 'green' : 'red';
      var categoryData = this.formatCatData(adsPlan);
      return /*#__PURE__*/React.createElement("div", {
        className: styles.wrapThis
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.leftColTextWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.leftColTextItem
      }, "Planned Ads Total: ", /*#__PURE__*/React.createElement("span", null, this.props.formatCurrency(plannedAdsTotal)))), plannedAdsTotal !== 0 && /*#__PURE__*/React.createElement("div", {
        className: styles.leftColChartWrap
      }, this.renderPieChart(adsPlan)), plannedAdsTotal !== 0 && /*#__PURE__*/React.createElement("div", {
        className: styles.leftColLegendWrap
      }, this.renderLegend(categoryData)));
    }
  }]);

  return AdsPlanLeftCol;
}(Component);

export { AdsPlanLeftCol as default };